import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { withRouter } from "react-router";
import { Route, Redirect, Switch } from "react-router-dom";

import Amplify, { Auth, Hub } from "aws-amplify";

import CssBaseline from "@material-ui/core/CssBaseline";

import Login from "./Login";

import Loading from "./components/Loading";

//window.LOG_LEVEL='DEBUG'

const Consilium = React.lazy(() => import("./consilium"));

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: window.Consilium.region,
    userPoolId: window.Consilium.userPoolId,
    identityPoolId: window.Consilium.identityPoolId,
    userPoolWebClientId: window.Consilium.appClientId,

  },
  Analytics: {
    disabled: true,
    autoSessionRecord: false
  }
});

const AuthRoute = ({ component: C, authenticated, authProtected, user, ...rest}) => (
  <Route
    {...rest}
    render={ props =>
        (!authProtected || authenticated) ? (
          <React.Suspense fallback={<Loading />}>
            <C user={user} {...props} />
          </React.Suspense>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
            />
        )
    }
  />
);

AuthRoute.propTypes = {
  component: PropTypes.any.isRequired,
  authenticated: PropTypes.bool,
  authProtected: PropTypes.bool.isRequired,
  user: PropTypes.object
};

function App() {

  const [authenticating, setAuthenticating] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function checkAuthentication() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        //console.log("user", user);
        setAuthenticated(true);
        setUser(user);
      }
      catch(err) {
        if (err !== "not authenticated") {
          console.error(err);
        }
        setAuthenticated(false);
      }
      setAuthenticating(false);
    }
    checkAuthentication();
  }, []);

  useEffect(() => {
    Hub.listen("auth", (data) => {
      //console.log("auth event");
      //console.log(data);
      if (data.payload.event === "signIn") {
        setAuthenticated(true);
        setUser(data.payload.data);
      } else if (data.payload.event === "signOut") {
        setAuthenticated(false);
        setUser(null);
      }
    });
    return () => {
      Hub.remove("auth");
    }
  }, []);

  if (authenticating) {
    return <Loading />;
  }

  // TODO: Add route for 404 no match.
  // Also, /login doesn't need to be an AuthRoute, it can be a regular route as it's public.

  return (
    <React.Fragment>
      <CssBaseline />
      <Switch>
        <AuthRoute
          path="/"
          component={Consilium}
          exact
          strict
          authenticated={authenticated}
          authProtected={true}
          user={user}
        />
        <AuthRoute
          path="/admin"
          component={Consilium}
          exact
          strict
          authenticated={authenticated}
          authProtected={true}
          user={user}
        />
        <AuthRoute
          path="/login"
          component={Login}
          exact
          strict
          authenticated={authenticated}
          authProtected={false}
        />
      </Switch>
    </React.Fragment>
  );
}

export default withRouter(App);
